import { render, staticRenderFns } from "./RiskAreaEvalutionStatistics.vue?vue&type=template&id=60c7281c&scoped=true"
import script from "./RiskAreaEvalutionStatistics.vue?vue&type=script&lang=js"
export * from "./RiskAreaEvalutionStatistics.vue?vue&type=script&lang=js"
import style0 from "./RiskAreaEvalutionStatistics.vue?vue&type=style&index=0&id=60c7281c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7281c",
  null
  
)

export default component.exports